
import * as api from '../api/api';
import wechat from '../utils/wx';
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import cityData from '../utils/city';
import getLocation from '../utils/getCurLoaction'
import IPhoneBg from '../assets/images/iPhonebg.jpg';
import Axios from 'axios';

var timer, count = 59, isCountDown = false;
let Debounce = (fn, delay, immediate = false) => {

let timer = null
let isInvoke = false


const _debounce = function(...args) {

if (timer) clearTimeout(timer)


if (immediate && !isInvoke) {
fn.apply(this, args)
isInvoke = true
} else {

timer = setTimeout(() => {

fn.apply(this, args)
isInvoke = false
}, delay)
}
}
return _debounce
}
export default {
components: {
PopupPicker
},
data() {
return {
city: undefined,
citys: [],
bac: "https://huiyuanxitong.oss-cn-hangzhou.aliyuncs.com/dhy/opportunity/bg1.png",
resultBac: "",
resultQr: "",
submitBgColor: "#FF8162",
loaded: false,
submitText: "提交",
formTitle: null,
formData: null,
oldIPhoneValue: '',
img: '',

errContents: "",
isShowErr: false,//是否显示错误提示

isShowAlert: false, //是否显示错误弹框
alertContent: "",    //错误弹框内容

activityInfo: null,

hasAuthorize: true,
companyList: [],
}
},
mounted() {
const uDom = document.querySelector('meta[name="unionId"]');
let unionId = uDom ? uDom.getAttribute('content') : '';


this.hasAuthorize = (!!unionId || !this._isWeiXinAgent());



document.body.style.backgroundImage = "url(" + this.bac + ")";

this.citys = this.getCityData(cityData);

this.$emit('header');
this.$emit('footer', false);

this.getFormData(this.$route.params.activity_id, (err, formData) => {
if (err) {
this.alertContent = err;
this.isShowAlert = true;

} else {
const activityInfo = formData.ActivityInfo;
this.activityInfo = activityInfo;
if (activityInfo) {
window.__myWebLogTracker__ &&
window.__myWebLogTracker__.report('体验表单-查看', {
id: activityInfo.ActivityGUID || "",
name: activityInfo.ActivityName || ""
});
}

document.title = activityInfo.ActivityName || "明源云";
this.formTitle = activityInfo.ActivityName;
this.resultBac = activityInfo.ResultImage || "";
const data = formData.FieldList, handlerData = [];
if (activityInfo.PhoneALLBackimage) {

document.getElementById("oppo-main").style.backgroundImage = "url(" + activityInfo.PhoneALLBackimage + ")";
} else {
document.getElementById("oppo-main").style.backgroundImage = "url(" + this.bac + ")";
}

this.submitBgColor = activityInfo.CommitColor ? activityInfo.CommitColor : '#FF8162';

for (let i = 0; i < data.length; i++) {
if (data[i].FieldCode === "Phione") {
this.oldIPhoneValue = data[i].Default;
handlerData.push(data[i]);
if (activityInfo.IsPhoneValid === 1) {
handlerData.push({
"SeqNum": 1,
"FieldCode": "validCode",
"FieldName": "验证码 ",
"FieldType": "validCode",
"IsMust": 1,
"IsLX": 1,
"CheckboxSet": null,
"Separator": null,
"Default": ""
});
}
} else if (data[i].FieldCode === "City") {
if (data[i].Default) {
const temp = this.citys.find(item => {
return item.name.indexOf(data[i].Default) >= 0;
});
if (temp) {
const parent = temp.parent === 0 ? temp.name : temp.parent;
const city = temp.name ? temp.name : temp.parent;
this.city = [parent, city];
}
} else {
try {
getLocation((data) => {
const cityName = data.result.addressComponent.city;
const temp = this.citys.find(item => {
return item.name.indexOf(cityName) >= 0;
});
if (temp) {
const parent = temp.parent === 0 ? temp.name : temp.parent;
const city = temp.name ? temp.name : temp.parent;
this.city = [parent, city];
}
});
} catch (ex) {

}

}
handlerData.push(data[i]);
} else {
handlerData.push(data[i]);
}
}
handlerData.IsPhoneRepeater = activityInfo.IsPhoneRepeater;
handlerData.IsPhoneValid = activityInfo.IsPhoneValid;
this.formData = handlerData;

this.loaded = true;













}
});

this.$ajax.get(api.get_activity_result_qr_code, {
params: {
clueId: this.$route.params.activity_id,
unionId: ""
}
}).then(res => {
if (res && res.result) {
this.resultQr = res.data.qrcode_img_url;
}
});

this.$ajax.get(api.weixin, {
params: {
signurl: location.href.split('#')[0]
}
}).then(res => {
this.wechatExist(function () {
let share = wechat(wx);
share.ready(void (0), {
link: location.href,
type: '',
dataUrl: '',
}, {
page: '',
id: ''
});

share.config(res['wx'])
})
});
},
beforeDestroy() {
this.$emit('header', true);
this.$emit('footer', true);

document.title = "明源云";

},
watch: {
'$route': function (to, from) {
this.$mount()
}
},
methods: {
getCheckBoxClass(data) {
let ret = "checkbox-item";
if (!!data) {
if (!!data.isOneCol) {
ret += " checkbox-item-full";
} else {
const checkboxArray = data.DictionarySet.split(data.Separator);
const overLenght = checkboxArray.findIndex(item => {
return item.length > 8;
});
if (overLenght !== -1) {
ret += " checkbox-item-full";
}
}
}
return ret;
},
getCityData(childrens, parent = 0) {
let ret = [];
for (let city of childrens) {
ret.push({name: city.label, value: city.label, parent});
const isZx = ['北京市', '天津市', '上海市', '重庆市', '香港特别行政区', '澳门特别行政区'].findIndex(item => item === city.label) >= 0;

if (city.children && parent === 0 && !isZx) {
ret = ret.concat(this.getCityData(city.children, city.label))
} else if (city.children && parent === 0 && isZx) {
ret.push({name: '', value: city.label, parent: city.label})
}
}
return ret;
},

setError(classNameStr, switchStr) {
let arr = document.getElementsByTagName('span');
classNameStr = classNameStr.toLocaleLowerCase();
for (let i = 0; i < arr.length; i++) {
const str = arr[i].getAttribute('class');
if (!!str && str.toLocaleLowerCase().indexOf(` ${classNameStr}`) >= 0) {
const baseClass = `error hidden ${classNameStr}`;
switchStr === 'show' ? arr[i].setAttribute('class', baseClass.replace('hidden', '')) : arr[i].setAttribute('class', baseClass);
}
}
},

_hasValidCode() {
let validCodeDiv = document.getElementsByClassName('valicodeWrap');
let result = false;
if (validCodeDiv.length >= 1) {
result = validCodeDiv[0].style.display !== 'none';
}
return result;
},

_getValidCode() {
let code = '';
let arr = document.getElementsByTagName('input');
for (let i = 0; i < arr.length; i++) {
if (arr[i].name === 'validCode') {
code = arr[i].value;
}
}

return code;
},

_checkField() {
let result = true;
let arr = Array.prototype.slice.call(document.getElementsByTagName('input'));
let textareaArr = Array.prototype.slice.call(document.getElementsByTagName('textarea'));
let hasValidCode = this._hasValidCode();
let isRequire = '';

arr = arr.concat(textareaArr);
for (let i = 0; i < arr.length; i++) {
const item = arr[i];
isRequire = item.getAttribute('data-require');

if (item.name === 'validCode') {
if (hasValidCode) {
if (item.value.replace(/(^\s*)|(\s*$)/g, '') === '') {
this.setError(item.name, 'show');
result = false;
} else if (item.value.replace(/(^\s*)|(\s*$)/g, '') !== '') {
this.setError(item.name, 'none');
}
}
} else {
if (isRequire === '1') {
if (item.value.replace(/(^\s*)|(\s*$)/g, '') === '') {
this.setError(item.name, 'show');
result = false;
} else if (item.value.replace(/(^\s*)|(\s*$)/g, '') !== '') {
if (item.name === 'Phione') {
if (!/^1[0-9]{10}$/.test(item.value)) {
this.setError(item.name, 'show');
result = false;
}
} else {
this.setError(item.name, 'none');
}
}
}
}
}


const checkboxWrap = document.getElementsByClassName('checkbox-wrap');
for (let k = 0; k < checkboxWrap.length; k++) {
const item = checkboxWrap[k],
dataName = item.getAttribute('data-name');
isRequire = item.getAttribute('data-require');

if (isRequire === '1') {
const childInputs = document.getElementsByTagName('input');
let hasSelected = false;
for (let s = 0; s < childInputs.length; s++) {
if (dataName === childInputs[s].name
&& (childInputs[s].type === 'checkbox' || childInputs[s].type === 'radio')
&& childInputs[s].checked) {
hasSelected = true;
}
}

if (!hasSelected) {
this.setError(dataName, 'show');
result = false;
} else if (hasSelected) {
this.setError(dataName, 'none');
}
}
}

return result;
},

_getSaveData() {
let FormDetail = [];
let totalTypeArray = [];
let arr = Array.prototype.slice.call(document.getElementsByTagName('input'));
let textareaArr = Array.prototype.slice.call(document.getElementsByTagName('textarea'));
arr = arr.concat(textareaArr);


for (let i = 0; i < arr.length; i++) {
const _type = arr[i].type,
_tagName = arr[i].tagName;
if (arr[i].getAttribute('data-field-name') === null) {
continue;
}
if (_tagName === 'INPUT') {
if (_type === 'text' || _type === 'number' || _type === 'tel') {
if (arr[i].name !== 'validCode') {
FormDetail.push({
"FieldCode": arr[i].name,
"FieldName": arr[i].getAttribute('data-field-name'),
"FieldValue": arr[i].value.replace(/(^\s*)|(\s*$)/g, '')
});
}
} else if ((_type === 'checkbox' || _type === 'radio') && totalTypeArray.indexOf(arr[i].name) === -1) {
totalTypeArray.push(arr[i].name);
}
} else if (_tagName === 'TEXTAREA') {
FormDetail.push({
"FieldCode": arr[i].name,
"FieldName": arr[i].getAttribute('data-field-name'),
"FieldValue": arr[i].value.replace(/(^\s*)|(\s*$)/g, '')
});
}
}


for (let j = 0; j < totalTypeArray.length; j++) {
const _name = totalTypeArray[j];
let _selectedVal = '',
_fieldName = '';

for (let s = 0; s < arr.length; s++) {
const _type = arr[s].type;
if (_type) {
if ((_type === 'checkbox' || _type === 'radio') && arr[s].name === _name) {
if (arr[s].checked) {
_selectedVal === '' ? _selectedVal = arr[s].value : _selectedVal += ',' + arr[s].value;
}
if (_fieldName === '') {
_fieldName = arr[s].getAttribute('data-field-name');
}
}
}
}

if (_fieldName != null) {
FormDetail.push({
"FieldCode": _name,
"FieldName": _fieldName,
"FieldValue": _selectedVal
});
}
}

return {
"ActivityName": this.formTitle,
"ActivityGUID": this.$route.params.activity_id,
"FeedbackGUID": null,
"Channel": this.$route.params.channel,
"FormDetail": FormDetail,
"Creator": '', //创建人传入空值
"IsPhoneRepeater": this.formData.IsPhoneRepeater,
"IsPhoneValid": this.formData.IsPhoneValid
}
},

_updateData(name, value) {
if (name === 'validCode')
return;

const arr = this.formData;
for (let i = 0; i < arr.length; i++) {
if (arr[i].FieldCode === name) {
arr[i].Default = value;
}
}
},
formatPicker(value) {
return value[1];
},
_change(type, fieldCode, isMust, changeType) {
if (type === 'input' || type === 'textarea') {
const arr = type === 'input' ? document.getElementsByTagName('input') : document.getElementsByTagName('textarea');
let Phione = null;
for (let i = 0; i < arr.length; i++) {
if (arr[i].name === fieldCode) {
fieldCode === 'Phione' ? Phione = arr[i] : this._updateData(fieldCode, arr[i].value.replace(/(^\s*)|(\s*$)/g, ''));
if (arr[i].value.replace(/(^\s*)|(\s*$)/g, '') !== '') {
this.setError(fieldCode, 'none');
if (fieldCode === 'CompanyName' && changeType === 'changeInput') {
this.searchCompanyName(arr[i].value);
break;
}
} else {
this.setError(fieldCode, 'show');
}
}
}

if (fieldCode === 'Phione' && Phione) {
const currentValue = Phione.value,
oldValue = this.oldIPhoneValue;
const validCodeDiv = document.getElementsByClassName('valicodeWrap')[0];
this._updateData(fieldCode, currentValue.replace(/(^\s*)|(\s*$)/g, ''));
if (!currentValue)
return false;
if (validCodeDiv)
currentValue !== oldValue ? validCodeDiv.style.display = 'flex' : validCodeDiv.style.display = 'none';
}
} else if (type === 'checkbox') {
const arr = document.getElementsByClassName('checkbox-wrap');
for (let i = 0; i < arr.length; i++) {
if (arr[i].getAttribute('data-name') === fieldCode) {
const childArr = document.getElementsByTagName('input');
let hasSelected = false;
for (let k = 0; k < childArr.length; k++) {
if (childArr[k].name === fieldCode && childArr[k].checked) {
hasSelected = true;
}
}
if (hasSelected) {
this.setError(fieldCode, 'none');
} else {
this.setError(fieldCode, 'show');
}
}
}
}
},

searchCompanyName: Debounce(function (val) {
let keyWord = val.trim();
if (!keyWord) {
this.companyList = [];
return;
}
Axios({
method: 'GET',
url: api.get_company_list,
params: {
keyWord: keyWord
}
}).then(res => {
let Data = res.data;
if (Data.Success) {
this.companyList = Data.Data.data || [];
}
})
}, 300),

_param(paramData) {
let key,
params = [],
escape = window.encodeURIComponent;
params.add = function (k, v) {
this.push(`${escape(k)}=${escape(v)}`)
};
for (key in paramData) {
if (paramData.hasOwnProperty(key)) {
params.add(key, paramData[key])
}
}
return params.join('&').replace(/%20/g, '+')
},

_isWeiXinAgent() {
const userAgent = navigator.userAgent;

return userAgent.indexOf('MicroMessenger') !== -1 || userAgent.indexOf('Windows Phone') !== -1;
},

sendSms() {

if (isCountDown)
return;

let mobile = '',
Phione = null;
const arr = document.getElementsByTagName('input');
for (let i = 0; i < arr.length; i++) {
if (arr[i].name === 'Phione') {
mobile = arr[i].value;
Phione = arr[i];
}
}

if (!mobile || !/^1[0-9]{10}$/.test(mobile)) {
Phione && this.setError(Phione.name, 'show');
return;
}

const verifyCodeDiv = document.getElementsByClassName('verifyCode')[0];
timer = setInterval(function () {
verifyCodeDiv.innerHTML = count + "s";
count--;
if (count === 0) {
verifyCodeDiv.innerHTML = "获取验证码";
isCountDown = false;
count = 59;
clearInterval(timer);
}
}, 1000);

isCountDown = true;
this.$ajax.get(api.send_sms_v2, {
params: {
mobile
}
})
.then(res => {
if (res['result']) {
}
}).catch(err => {

})
},

getFormData(id, cb) {
const uDom = document.querySelector('meta[name="unionId"]');
const unionId = uDom ? uDom.getAttribute('content') : '';

this.$ajax.get(`${api.get_activity_form_v2}`, {
params: {
activity_id: id,
union_id: unionId
}
}).then(res => {
if (res['result'] && res['data']) {
if (cb) {
cb(false, res['data'])
}
} else {
cb(res['msg'], false)
}
}).catch(err => {
if (cb) {
cb(err)
}
})
},

saveFormData(data, cb) {

this.$ajax.post(`${api.save_activity_form_v2}`, data).then(res => {
if (res['result'] && res['data']) {
if (cb) {
cb(true, res['data'])
}
} else {
cb(false, res['msg'])
}
}).catch(err => {
if (cb) {
cb(false, err)
}
})
},

wechatExist(cb) {
let timer = null;
timer = setInterval(() => {
if ('wx' in window) {
clearInterval(timer);
if (cb) {
cb()
}
}
}, 200)
},
authorize() {
const authUrl = location.origin + location.pathname + '?_m=open';

window.location.href = authUrl;
},
cancelAuthorize() {
this.hasAuthorize = true;
},
submit() {
if (this._checkField()) {
if (this.submitText === '提交中...') return;
this.submitText = '提交中...';





let validCode = '';
if (this._hasValidCode()) {
validCode = this._getValidCode();
}
const uDom = document.querySelector('meta[name="unionId"]');
const unionId = uDom ? uDom.getAttribute('content') : '';

this.saveFormData({
content: this._getSaveData(),
validCode,
union_id: unionId
}, (result, data) => {

if (result) {
if (this.activityInfo) {
window.__myWebLogTracker__ &&
window.__myWebLogTracker__.report('体验表单-提交', {
id: this.activityInfo.ActivityGUID || "",
name: this.activityInfo.ActivityName || ""
});
}
this.submitText = '提交';
this.$router.push({name: 'result', params: {qr: this.resultQr, bac: this.resultBac}});
} else {

this.submitText = '提交';
this.isShowErr = true;
this.errContents = data;
}
});
}
},

onHide() {
this.isShowErr = !this.isShowErr;
},

hideAlert() {
this.isShowAlert = false;
this.$router.push({name: 'Tel'});
},
chooseItem(val) {
let inputElement = document.getElementsByTagName('input');
for (let i = 0; i < inputElement.length; i++) {
const item = inputElement[i];
if (item.name === 'CompanyName') {
this._updateData(item.name, val);
}
}
this.companyList = [];
},
}
}



// WEBPACK FOOTER //
// ./src/components/opportunity.vue